import {
  Checkbox,
  ListItem,
  ListItemText,
  withStyles,
  WithStyles
} from '@material-ui/core';
import * as React from 'react';

interface IListItemProps extends WithStyles<typeof styles> {
  isChecked: boolean;
  name: string;
  onCheckItem: (name: string, isChecked: boolean) => void;
  readOnly?: boolean;
}

const styles = {
  listItem: {
    paddingTop: 0,
    paddingBottom: 0
  },
  checkbox: { zIndex: -1 }
};

const CheckboxListItem: React.FC<IListItemProps> = props => {
  const { classes, isChecked, name, onCheckItem } = props;

  return (
    <ListItem disabled={props.readOnly} style={{ padding: 0 }} button={true} onClick={() => {
      onCheckItem(name, isChecked);
    }} className={classes.listItem}>
      <Checkbox
        disabled={props.readOnly}
        className={classes.checkbox}
        checked={isChecked}
        value={name}
        edge="start"
      />
      <ListItemText>{name}</ListItemText>
    </ListItem>
  );
}

export default withStyles(styles)(CheckboxListItem);
